import script from "./product-details.vue?vue&type=script&setup=true&lang=js"
export * from "./product-details.vue?vue&type=script&setup=true&lang=js"

import "./product-details.vue?vue&type=style&index=0&id=1142563a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1142563a"]])

export default __exports__